import React, { useEffect } from "react";
import { useSubscription, gql } from "@apollo/client";
import { useStore } from "../store";
import DroneMap from "../components/Map/DroneMap";
import DronePanel from "../components/DronePanel/DronePanel";
import ThreatBar from "../components/ThreatBar/ThreatBar";
import { Drone } from "../types";
import "../Dashboard.css";

const DRONE_UPDATED_SUB = gql`
  subscription OnDroneUpdated {
    droneUpdated {
      droneId
      model
      lat
      lng
      altitudeM
      speedMs
      directionDeg
      signalDb
      sensorType
      frequencyMhz
      distanceM
      reliability
      deviceId
      tenantId
      detectedAt
      isActive
    }
  }
`;

const DRONE_DETECTED_SUB = gql`
  subscription OnDroneDetected {
    droneDetected {
      droneId model lat lng altitudeM speedMs directionDeg signalDb
      sensorType frequencyMhz distanceM reliability deviceId detectedAt isActive
    }
  }
`;

const DRONE_LOST_SUB = gql`
  subscription OnDroneLost {
    droneLost
  }
`;

export default function Dashboard() {
  const { setDrone, removeDrone, setMapCenter, setSelectedDrone, drones, pruneStale } = useStore();

  useSubscription(DRONE_UPDATED_SUB, {
    onData: ({ data }) => {
      const drone: Drone = data?.data?.droneUpdated;
      if (drone?.droneId) setDrone(drone);
    },
  });

  useSubscription(DRONE_DETECTED_SUB, {
    onData: ({ data }) => {
      const drone: Drone = data?.data?.droneDetected;
      if (drone?.droneId) setDrone(drone);
    },
  });

  useSubscription(DRONE_LOST_SUB, {
    onData: ({ data }) => {
      const droneId: string = data?.data?.droneLost;
      if (droneId) removeDrone(droneId);
    },
  });

  const handleDroneSelect = (droneId: string) => {
    setSelectedDrone(droneId);
    const drone = drones.get(droneId);
    if (drone?.lat && drone?.lng) {
      setMapCenter([drone.lat, drone.lng]);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <ThreatBar />
      <div className="dashboard" style={{ flex: 1, minHeight: 0 }}>
        <DronePanel onDroneSelect={handleDroneSelect} />
        <div className="dashboard-map">
          <DroneMap onDroneClick={handleDroneSelect} />
        </div>
      </div>
    </div>
  );
}
